export const messages = {
  lowMemory: {
    id: "startup.lowMemory",
    defaultMessage: "Low Memory Warning",
  },
  lowMemoryDescription: {
    id: "startup.lowMemoryDescription",
    defaultMessage:
      "The app might not work as intended. It is advisable to close other applications before continuing",
  },
};
